<template>
  <div>
    <v-card dark>
      <v-card-text>
        <v-data-table
          hide-default-footer
          :items="ordersList"
          :headers="headerList"
          :loading="loadingItems"
          :item-class="getEstiloLinha"
          no-data-text="Sem registros para exibir"
          loading-text="Carregando dados..."
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title class="text-h6"
                >Últimos Orçamentos</v-toolbar-title
              >
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-row dense class="d-flex justify-end">
                <v-spacer></v-spacer>
                <v-col cols="3" sm="6" md="4">
                  <v-select
                    v-model="searchFields.option"
                    label="Opções de busca"
                    item-text="label"
                    item-value="value"
                    class="text-caption mr-2"
                    :items="optionsHeaderFields"
                    solo
                    dense
                    hide-details
                    @change="requestOrders()"
                  />
                </v-col>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      color="success"
                      v-on="on"
                      v-bind="attrs"
                      @click="requestOrders()"
                      class="mt-3"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                  </template>
                  <span>Recarregar Ultimos Orçamentos</span>
                </v-tooltip>
              </v-row>
            </v-toolbar>
          </template>

          <template
            v-for="(header, index) in this.headerList"
            v-slot:[`item.${header.value}`]="{ item }"
          >
            <td
              v-if="header.value === 'valor'"
              :key="index"
              class="d-flex justify-end"
            >
              {{ formatCurrency(item.moeda, item.valor) }}
            </td>

            <td v-else-if="header.value === 'sequencial'" :key="index">
              {{ formatSequencial(item.sequencial) }}
            </td>
            <td v-else-if="header.value == 'data'" :key="index">
              {{
                item.data
                  ? new Date(item[header.value] + '-03:00').toLocaleDateString(
                      'pt-BR'
                    )
                  : null
              }}
            </td>
            <td
              v-else-if="header.value === 'open'"
              :key="index"
              class="d-flex justify-end"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn-toggle tile>
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      color="success"
                      class="rounded-sm"
                      x-small
                      @click="loadOrder(item)"
                    >
                      <span class="text-overline">
                        Carregar
                      </span>
                      <v-icon color="white" small>
                        mdi-download
                      </v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </template>
                <span>Carregar Orçamento [{{ item.numero }}]</span>
              </v-tooltip>
            </td>
            <td v-else :key="index">
              {{ item[header.value] }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'

// import { formatSequencial } from '@/utils/utils'
export default {
  mixins: [currencyMixin],
  data: () => ({
    optionsHeaderFields: [
      { label: 'Finalizados', value: 'P' },
      { label: 'Não finalizados', value: 'W' },
      { label: 'Cancelados', value: 'C' },
      { label: 'Liberados', value: 'S' },
      { label: 'Todos', value: 'T' },
    ],
    searchFields: {
      option: 'P',
    },
  }),
  computed: {
    ...mapState('authModule', ['authUser']),
    ...mapGetters({
      ordersList: 'pdvBalcaoModule/orderModule/getOrdersList',
    }),
    // Company Module
    ...mapState('companyModule', ['companyList']),
    // Departament Module
    ...mapState('departamentModule', ['departamentList']),
    // PDV Balcao Module
    ...mapState('pdvBalcaoModule/orderModule', ['order', 'loadingItems']),
    headerList() {
      return [
        { text: 'Cliente', value: 'razaoSocial' },
        { text: 'Numero', value: 'numero', width: 200 },
        { text: 'Serie', value: 'serie', width: 80 },
        { text: 'Valor', value: 'valor', align: 'right' },
        { text: 'Data', value: 'data', width: 100 },
        { text: 'Hora', value: 'hora', width: 100 },
        { text: 'Liberado', value: 'liberado', width: 100, align: 'right' },
        { text: 'Ações', value: 'open', width: 100, align: 'center' },
      ]
    },
  },
  methods: {
    ...mapActions({
      loadOrderAPI: 'pdvBalcaoModule/orderModule/loadOrder',
      setLoadingMessage: 'dialogModule/setLoadingDialogMessage',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      getOrders: 'pdvBalcaoModule/orderModule/getOrders',
    }),
    getEstiloLinha(value) {
      let res = this.$vuetify.breakpoint.mobile ? 'text-caption ' : ''
      switch (value.liberado) {
        case 'W':
          res += 'yellow--text '
          break

        case 'S':
          res += 'font-weight-bold '
          break

        default:
          break
      }
      return res
    },
    formatSequencial(sequencial) {
      return sequencial.split('.')[0]
    },
    async loadOrder(item) {
      let loadObject = {}
      loadObject['numero'] = item.numero
      loadObject['serie'] = item.serie
      this.$emit('loadOrder', loadObject)
    },
    async requestOrders() {
      const payload = {
        liberado: this.searchFields.option,
        ultimosOrcamentos: 10,
      }
      try {
        if (this.authUser.guest) {
          await this.getOrders({
            ...payload,
            codigoEmpresa: this.authUser.CODIGO,
          })
          this.$toasted.success(
            `Orçamentos de [${this.authUser.RAZAOSOCIAL}] carregados com sucesso`
          )
        } else {
          await this.getOrders(payload)
          this.$toasted.success('Orçamentos carregados com sucesso')
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  mounted() {
    this.requestOrders()
  },
}
</script>

<style></style>
